import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

const endPointFamiliares = environment.hostService + '/Familiares';

@Injectable({
  providedIn: 'root'
})

export class FamiliaresService {

  constructor(private _http: HttpClientService) { }

  getHistoryByClase(idPersonal: number, idClase: number, nroDoc: string): Observable<any>
  {
    return this._http.get<any>({ url: endPointFamiliares + '/GetHistoryByClase/' + idPersonal + '/' + idClase + '/' + nroDoc })
  }

  getFamiliares(id, agrupar): Observable<any>
  {
    return this._http.get<any>({ url: endPointFamiliares + '/GetFamiliaresPersonalByPersonalId/' + id + '/' + agrupar, cacheMins: 0 })
  }

  guardar(data, cortarRegistro): Observable<any>
  {
    return this._http.post<any>({ url: endPointFamiliares + '/Save/' + cortarRegistro, body: data, cacheMins: 0 });
  }

  eliminar(id): Observable<any>
  {
    return this._http.get<any>({ url: endPointFamiliares + '/Delete?id=' + id });
  }

  getFormatoImportacion() {
    const formato = [
      { personal: 0,
        desde: '00/00/0000',
        hasta: '00/00/0000',
        claseFamilia: '', 
        nombre: '',
        apellido: '',
        segundoApellido: '',
        sexo: '',
        claseDocumento: '',
        docNro: '',
        fechaNacimiento: '',
        pais: '',
        nacionalidad: '',
        estadoCivil: '',
        celular: '',
        email: '',
        discapacitado: 'true/false',
        presentacionCertificado: '',
        contactoEmergencia: 'true/false',
        errores: ['No Completar']}
    ];

    //claseFamilia, sexo, claseDocumento, pais, nacionalidad y estado civil se deben validar que existan

    return formato;
  }
}
